import { getDomainBaseUrl } from '@ugc-utils/domains';
import { get } from '../index';

const getProduct = pid => get(`${getDomainBaseUrl('catalog')}/ugc/api/product/v2/${pid}`);

export { getProduct };
